import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { LoginService } from '../login/login.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  constructor(private http: HttpClient, private loginService: LoginService) { }
  
  public getBooksFromHotel(): Observable<any> {   // TODO Hotel id is for admin query 
      const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.loginService.getToken()}` } ) };
      return this.http.get<Object>( environment.apiGetbooksfromhotel, httpOptions )
          .pipe(
          tap( _ => console.log( `fetched hotel` ) ),
          catchError( this.handleError( 'getHotel', null ) )
          );
  }      
  
  public updateTransaction( transaction:number, hotelprice:number ): Observable<any> {
      // const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.loginService.getToken()}` } ) };
      const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json' } ) };
      return this.http.post(
          environment.apiUpdatetransaction,
          JSON.stringify( {transaction:{
                  transaction: transaction,
                  hotelprice: hotelprice
              }
          } ), httpOptions )
          .pipe(
          tap( _ => console.log( `updated Transaction:${transaction}` ) ),
          catchError( this.handleError( 'updateTransaction', null ) )
          );
      ;
  }  
  
  public updateBooking( book:number, field:string, value:string ): Observable<any> {
      // const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.loginService.getToken()}` } ) };
      const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json' } ) };
      return this.http.post(
          environment.apiUpdatebooking,
          JSON.stringify( {book:book,
              field:field,
              value:value
          } ), httpOptions )
          .pipe(
          tap( _ => console.log( `updated Booking:${book}` ) ),
          catchError( this.handleError( 'updateBooking', null ) )
          );
      ;
  }
  
  public getcard( book:number, code:string ): Observable<any> {
      const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.loginService.getToken()}` } ) };
      // const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json' } ) };
      return this.http.get( environment.apiGetcard + '/' + book + '-' + code, httpOptions )
          .pipe(
          tap( _ => console.log( `Got Card for book:${book}` ) ),
          catchError( this.handleError( 'getcard', null ) )
          );
      ;
  }
  
  private handleError<T>( operation = 'operation', result?: T ) {
      return ( error: any ): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      if (error) console.log( error ); // log to console instead

      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of( result as T );
      };
  }      
  
}
